import React, { useState, useEffect } from "react";
import { Tab, Tabs } from "@mui/material";
import { useNavigate, useLocation } from "react-router-dom";
import TabPanel from "../../components/common/tabpannel/Tabpannel";
import Myprofile from "./myprofile/Myprofiletab";
import Chattab from "./chat/Chattab";
import Subscriptiontab from "./subscriptions/Subscriptiontab";
import AdsTab from "./ads/Adstab";
import Favoritetab from "./favorites/Favoritestab";
import Orderstab from "./orders/Orderstab";

const Myaccount = () => {
  const [selectedTab, setSelectedTab] = useState(0);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if (location.pathname === "/myaccount/myprofile") {
      setSelectedTab(0);
    } else if (location.pathname === "/myaccount/chat") {
      setSelectedTab(1);
    } else if (location.pathname === "/myaccount/subscription") {
      setSelectedTab(2);
    } else if (location.pathname === "/myaccount/mylisting") {
      setSelectedTab(3);
    } else if (location.pathname === "/myaccount/favorite") {
      setSelectedTab(4);
    } else if (location.pathname === "/myaccount/orders") {
      setSelectedTab(5);
    }
  }, [location.pathname]);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    if (newValue === 0) {
      navigate("/myaccount/myprofile");
    } else if (newValue === 1) {
      navigate("/myaccount/chat");
    } else if (newValue === 2) {
      navigate("/myaccount/subscription");
    } else if (newValue === 3) {
      navigate("/myaccount/mylisting");
    } else if (newValue === 4) {
      navigate("/myaccount/favorite");
    } else if (newValue === 5) {
      navigate("/myaccount/orders");
    }
  };

  return (
    <div>
      {/* Add the Tabs component to show tab labels */}
   

      <div className="p-5">
        <TabPanel value={selectedTab} index={0}>
          <Myprofile />
        </TabPanel>
        <TabPanel value={selectedTab} index={1}>
          <Chattab />
        </TabPanel>
        <TabPanel value={selectedTab} index={2}>
          <Subscriptiontab />
        </TabPanel>
        <TabPanel value={selectedTab} index={3}>
          <AdsTab />
        </TabPanel>
        <TabPanel value={selectedTab} index={4}>
          <Favoritetab />
        </TabPanel>
        <TabPanel value={selectedTab} index={5}>
          <Orderstab />
        </TabPanel>
      </div>
    </div>
  );
};

export default Myaccount;